<template>
    <div>
        <el-row>
            <el-col :span="20">
                <div class="grid-content bg-purple-light" >
                    <div class="searchTitle2">
                        <b style="font-size: 20px !important;"> 인증 통계 TOP 30</b>
                    </div>

                    <div class="searchBody report4-search-row">
                        <div class="searchBody_year" style="font-size: 15px !important;">
                            기간
                        </div>
                        <div class="searchBody report4-period-options">
                            <el-radio-group v-model="chk_date_end_date" @change="handleCheckedChange">
                                <el-radio :label="1">최근 1개월</el-radio>
                                <el-radio :label="3">최근 3개월</el-radio>
                                <el-radio :label="6">최근 6개월</el-radio>
                                <el-radio :label="9">최근 9개월</el-radio>
                                <el-radio :label="12">최근 12개월</el-radio>
                                <el-radio :label="0">전체</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="report-date-search">
                        <span class="report-date-search__label">조회 기간</span>
                        <el-date-picker v-model="customStartDate" type="date" placeholder="시작일"
                                        value-format="yyyy-MM-dd" class="report-date-search__input"></el-date-picker>
                        <span class="report-date-search__separator">~</span>
                        <el-date-picker v-model="customEndDate" type="date" placeholder="종료일"
                                        value-format="yyyy-MM-dd" class="report-date-search__input"></el-date-picker>
                        <el-button type="primary" icon="el-icon-search" class="report-date-search__button"
                                   @click="searchByDateRange">조회</el-button>
                        <el-button type="success" icon="el-icon-download" class="report-date-search__excel-button"
                                   :disabled="tableData4.length === 0" @click="excelDownFuncAll">Excel 다운로드</el-button>
                    </div>

                </div>
            </el-col>
        </el-row>


        <el-row>
            <el-col :span="20">
                <div class="grid-content bg-purple-light"  >

                    <div class="searchTitle2">
                        <b style="font-size: 20px !important;"> 인증코드 조회  </b>
                    </div>
                    <!-- 조회 조건 영역 -->


                    <div class="searchBody">
                        <div class="searchBody_year" style="font-size: 15px !important;">
                            인증코드
                        </div>
                        <div class="searchBody">
                            <el-input
                                v-model.trim="auth_code"
                                placeholder=""
                                clearable


                                @clear="clearAuthCode">
                            </el-input>
                        </div>
                        <div class="searchBody">
                            <div
                                class="searchBody_brand"
                                style="margin-left: 10px !important;"
                            >
                                <el-button
                                    :loading="loading"
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="search4"
                                >조회</el-button>

                            </div>




                        </div>
                    </div>
                </div> <!-- div class="grid-content bg-purple-light"> -->
            </el-col>
        </el-row>


        <el-row>
            <el-col :span="20">
                <div class="grid-content bg-purple-light" >

                    <!--        <el-radio-group v-model="chk_date_end_date"    @change="handleCheckedChange">-->
                    <!--          <el-radio :label="1">최근 1개월</el-radio>-->
                    <!--          <el-radio :label="3">최근 3개월</el-radio>-->
                    <!--          <el-radio :label="6">최근 6개월</el-radio>-->
                    <!--          <el-radio :label="9">최근 9개월</el-radio>-->
                    <!--          <el-radio :label="12">최근 12개월</el-radio>-->
                    <!--          <el-radio :label="0">전체</el-radio>-->
                    <!--        </el-radio-group>-->



                    <el-table
                            v-loading="loading"
                            ref="multipleTable4"
                            :data="tableData4"
                            style="width: 100%; height:100%"
                            border
                            @selection-change="handleSelectionChange"
                            :row-class-name="tableRowClassName"
                            size="small"
                            :row-style="{ height: 0 + 'px' }"
                            :cell-style="{ padding: 0 + 'px' }"
                            :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
                    >
                        <el-table-column
                                label="인증코드"
                                width="150">


                            <template slot-scope="scope">
                                <!--          <el-button @click="handleClick" type="text" size="small">Detail</el-button>-->
                                <el-button type="text" size="small" @click="handleClick4(scope.row.auth_code  ) " >{{scope.row.auth_code}}</el-button>
                            </template>

                        </el-table-column>


                        <el-table-column
                                property="dept_name"
                                label="회사명"
                                width="650">
                        </el-table-column>



<!--                        <el-table-column-->
<!--                                property="auth_key"-->
<!--                                label="인증키"-->
<!--                                width="120">-->
<!--                        </el-table-column>-->


                        <el-table-column
                                property="count"
                                label="count"
                                width="100">
                        </el-table-column>

                    </el-table>

                </div>
            </el-col>
        </el-row>


        <el-dialog
                title="map"
                :visible.sync="dialogVisible"
                custom-class="report-detail-dialog"
                width="75%"
                height="500px"
                v-loading="loading"
                :before-close="Confirm"
                :close-on-click-modal="false"
        >

            <el-row>
                <el-col :span="30">
                    <div class="grid-content bg-purple-light"  style="width: 100% !important; margin-top: 20px !important;">
                        <div class="dialog-excel-actions">
                            <el-button type="success" icon="el-icon-download"
                                       :disabled="tableData4_1.length === 0"
                                       @click="downloadDialogExcel">Excel 다운로드</el-button>
                        </div>
                        <el-table
                                v-loading="loading"
                                ref="multipleTable4"
                                :data="tableData4_1"
                                style="width: 100%; height:100%"
                                border
                                @selection-change="handleSelectionChange"
                                :row-class-name="tableRowClassName"
                                size="small"
                                :row-style="{ height: 0 + 'px' }"
                                :cell-style="{ padding: 0 + 'px' }"
                                :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
                        >
                            <el-table-column
                                    property="auth_code"
                                    label="인증코드"
                                    width="180">

                            </el-table-column>



                            <el-table-column
                                    property="dept_name"
                                    label="회사명"
                                    width="350"

                            >
                            </el-table-column>



                            <!--                  <el-table-column-->
                            <!--                      property="auth_key"-->
                            <!--                      label="인증키"-->
                            <!--                      width="120">-->
                            <!--                  </el-table-column>-->

                            <el-table-column
                                    property="country"
                                    label="국가"
                                    width="120">
                            </el-table-column>

                            <!--                  <el-table-column-->
                            <!--                      property="administrative_area_level_1"-->
                            <!--                      label="도시"-->
                            <!--                      width="220">-->
                            <!--                  </el-table-column>-->

                            <el-table-column
                                    property="chk_date"
                                    label="인증날짜"
                                    width="120">
                            </el-table-column>

                            <el-table-column
                                    property="success_fail"
                                    label="성공여부"
                                    width="80">
                            </el-table-column>

                            <el-table-column
                                    property="count"
                                    label="count"
                                    width="80">
                            </el-table-column>

                        </el-table>
                    </div>
                </el-col>
            </el-row >


            <el-row>
                <el-col :span="23">
                    <div  class="grid-content-report" >

                        <div>
                            <gmap-map :zoom="10" :center="center" style="width:100%; height: 380px;" >
                                <gmap-marker :key="index" v-for="(m, index) in locationMarkers"
                                             :position="m.position"
                                             :icon="m.icon"
                                             :animation="m.ani"
                                ></gmap-marker>

                            </gmap-map>
                        </div>

                    </div>
                </el-col>

            </el-row>
        </el-dialog>




    </div>
</template>
<style>

.grid-content1 {
    height: 215px;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}

.grid-content2 {
    height: 100%;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}



.grid-content3 {
    height: 100%;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}

.grid-content4 {
    height: 100%;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}


.grid-content5 {
    height: 100%;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}


/*.row-bg {*/
/*  height: 400px;*/
/*  width:  1000px;*/
/*  !*border-style:solid;*!*/
/*  border-top-width: thin;*/
/*  border-bottom-width: thin;*/
/*  border-left-width: thin;*/
/*  border-right-width: thin;*/
/*  border-color : #8c939d;*/
/*}*/
</style>

<script>

// import BarChart from '@/views/components/MonthReportBarChart'
// import BarChart2 from '@/views/components/CountryReportBarChar'
// import BarChart3 from '@/views/components/AreaReportBarChar'
import Axios from "axios";
import XLSX from "xlsx";
// import AddGoogleMapReport from '@/views/components/AddGoogleMapReport'

export default {
    name: 'VueChartJS',
    components: {

        // BarChart,
        // BarChart2,
        // BarChart3,
        // AddGoogleMapReport,


    },

    created() {

        document.onkeydown = this.NotReload;


        this.$store.commit("dayBefore",0);
        this.requestEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜
        this.$store.commit("dayBefore",7);
        this.requestStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일

        this.setDateRangeByMonths(this.chk_date_end_date);

        // 페이지로딩시 조회
        // this.search();
        // this.search2();
        // this.search3();
        this.search4();

    },//created

    data() {
        return {

            tableData: [],
            totalData: [],
            multipleSelection: [],

            tableData2: [],
            totalData2: [],
            multipleSelection2: [],


            tableData3: [],
            totalData3: [],
            multipleSelection3: [],

            tableData4: [],
            totalData4: [],
            multipleSelection4: [],
            tableData4_1: [],
            totalData4_1: [],
            multipleSelection4_1 : [],


            dialogVisible : false,



            center: { lat: 37.4915792, lng: 126.8788277},

            locationMarkers: [

            ],

            locPlaces: [],
            label : [],
            existingPlace: null,
            chk_date_end_date: 1,
            customStartDate: '',
            customEndDate: '',
            useCustomDateRange: false,
            auth_code : '',

        };
    },

    mounted() {
        this.geolocate();
    },


    methods: {


        handleCheckedChange(){
            this.useCustomDateRange = false;
            this.setDateRangeByMonths(this.chk_date_end_date);
            if (this.chk_date_end_date=="0")
                this.$message.success("젠체 데이터 조회 중입니다.");
            else
                this.$message.success("최근" + this.chk_date_end_date + "개월 데이터 조회 중입니다.");


            this.search4();
        },

        setDateRangeByMonths(months){
            if (months === 0 || months === '0' || months == null) {
                this.customStartDate = '';
                this.customEndDate = '';
                return;
            }
            const endDate = new Date();
            const startDate = new Date(endDate.getFullYear(), endDate.getMonth() - Number(months), 1);
            const lastDay = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0).getDate();
            startDate.setDate(Math.min(endDate.getDate(), lastDay));
            this.customStartDate = this.formatDate(startDate);
            this.customEndDate = this.formatDate(endDate);
        },

        formatDate(date){
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        searchByDateRange(){
            if (!this.customStartDate || !this.customEndDate) {
                this.$message.warning("조회할 시작일과 종료일을 선택해 주세요.");
                return;
            }
            if (this.customStartDate > this.customEndDate) {
                this.$message.warning("시작일은 종료일보다 늦을 수 없습니다.");
                return;
            }
            this.chk_date_end_date = null;
            this.useCustomDateRange = true;
            this.search4();
        },

        applyDateFilter(reqJson){
            if (this.useCustomDateRange && this.customStartDate && this.customEndDate) {
                reqJson.custom_start_date = this.customStartDate;
                reqJson.custom_end_date = this.customEndDate;
            } else if (this.chk_date_end_date != null && this.chk_date_end_date != '0') {
                reqJson.chk_date_end_date = this.chk_date_end_date;
            }
        },

        async search(){
            this.loading = true;

            let url = this.$url + '/authInfo/getMonthDailyAuth';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData.push({
                            seq : resData,
                            chk_date  :  resDataJson[resData]['chk_date'] ,
                            count :  resDataJson[resData]['count'] * 1
                        });
                    }

                    this.tableData =  this.totalData
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search




        async search2(){
            this.loading = true;

            let url = this.$url + '/authInfo/getCountryReportAuth';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData2 =[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData2.push({
                            seq : resData,
                            country  :  resDataJson[resData]['country'] ,
                            count :  resDataJson[resData]['count'] * 1
                        });
                    }

                    this.tableData2 =  this.totalData2
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search2


        async search3(){
            this.loading = true;

            let url = this.$url + '/authInfo/getAreaReportAuth';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData3=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData3.push({
                            seq : resData,
                            administrative_area_level_1  :  resDataJson[resData]['administrative_area_level_1'] ,
                            count :  resDataJson[resData]['count'] * 1
                        });
                    }

                    this.tableData3 =  this.totalData3
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search3



        async search4(){
            this.loading = true;

            let url = this.$url + '/authInfo/getAuthReportFail';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;


            this.applyDateFilter(reqJson);

            const authCode = this.extractAuthCode(this.auth_code);
            if (authCode != '')
                reqJson.auth_code = authCode;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData4=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData4.push({
                            seq : resData,
                            auth_code  :  resDataJson[resData]['auth_code'] ,
                            auth_key  :  resDataJson[resData]['auth_key'] ,
                            // country  :  resDataJson[resData]['country'] ,
                            // administrative_area_level_1  :  resDataJson[resData]['administrative_area_level_1'] ,
                            // success_fail  :  resDataJson[resData]['success_fail'] ,
                            // chk_date :  resDataJson[resData]['chk_date'] ,
                            count :  resDataJson[resData]['count'] * 1 ,
                            dept_name :  resDataJson[resData]['dept_name']
                        });
                    }

                    this.tableData4 =  this.totalData4
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search4

        clearAuthCode(){
            this.auth_code = '';
            this.search4();
        },

        extractAuthCode(value){
            if (value == null)
                return '';

            const keyword = String(value).trim();
            if (keyword == '')
                return '';

            try {
                const parsedUrl = new URL(keyword);
                const authCode = parsedUrl.searchParams.get('A') || parsedUrl.searchParams.get('a');
                if (authCode != null && authCode.trim() != '')
                    return authCode.trim();
            } catch (e) {
                // 일반 인증코드 입력은 URL 파싱 대상이 아닙니다.
            }

            const match = keyword.match(/[?&]A=([^&#]+)/i);
            if (match != null && match[1] != null)
                return decodeURIComponent(match[1]).trim();

            return keyword;
        },



        async search6(){
            this.loading = true;

            let url = this.$url + '/authInfo/getAuthReportFail';
            var reqJson = new Object();

            if (this.auth_code == '')
            {
                this.$message.error(" 인증코드를 입력해주세요  ");
                return false;
            }

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

            this.chk_date_end_date = 0;
            reqJson.auth_code = this.auth_code;

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData4=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData4.push({
                            seq : resData,
                            auth_code  :  resDataJson[resData]['auth_code'] ,
                            auth_key  :  resDataJson[resData]['auth_key'] ,
                            // country  :  resDataJson[resData]['country'] ,
                            // administrative_area_level_1  :  resDataJson[resData]['administrative_area_level_1'] ,
                            // success_fail  :  resDataJson[resData]['success_fail'] ,
                            // chk_date :  resDataJson[resData]['chk_date'] ,
                            count :  resDataJson[resData]['count'] * 1 ,
                            dept_name :  resDataJson[resData]['dept_name']
                        });
                    }

                    this.tableData4 =  this.totalData4
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search4



        async search4_1(auth_code, administrative_area_level_1, country, chk_date){
            this.loading = true;

            let url = this.$url + '/authInfo/getAuthReportFail';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

            reqJson.auth_code = auth_code;
            reqJson.administrative_area_level_1 = administrative_area_level_1;
            reqJson.country = country;
            reqJson.chk_date = chk_date;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData4_1=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData4_1.push({
                            seq : resData,
                            auth_code  :  resDataJson[resData]['auth_code'] ,
                            auth_key  :  resDataJson[resData]['auth_key'] ,
                            // country  :  resDataJson[resData]['country'] ,
                            // administrative_area_level_1  :  resDataJson[resData]['administrative_area_level_1'] ,
                            // success_fail  :  resDataJson[resData]['success_fail'] ,
                            // chk_date : resDataJson[resData]['chk_date'] ,
                            count :  resDataJson[resData]['count'] * 1,
                            dept_name :   resDataJson[resData]['dept_name']
                        });
                    }

                    this.tableData4_1 =  this.totalData4_1
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search4


        async search4_2(auth_code){
            this.loading = true;

            let url = this.$url + '/authInfo/getAuthReport2';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

            this.applyDateFilter(reqJson);




            reqJson.auth_code = auth_code;
            // reqJson.administrative_area_level_1 = administrative_area_level_1;
            // reqJson.country = country;
            // reqJson.chk_date = chk_date;
            // reqJson.success_fail = success_fail;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO
                this.totalData4_1=[];
                if (res.data.resultCode){
                    for(var resData in resDataJson){
                        this.totalData4_1.push({
                            seq : resData,
                            auth_code  :  resDataJson[resData]['auth_code'] ,
                            auth_key  :  resDataJson[resData]['auth_key'] ,
                            country  :  resDataJson[resData]['country'] ,
                            administrative_area_level_1  :  resDataJson[resData]['administrative_area_level_1'] ,
                            success_fail  :  resDataJson[resData]['success_fail'] ,
                            chk_date : resDataJson[resData]['chk_date'] ,
                            count :  resDataJson[resData]['count'] * 1 ,
                            dept_name :   resDataJson[resData]['dept_name']
                        });
                    }

                    this.tableData4_1 =  this.totalData4_1
                    this.loading = false;
                    this.$message.success(this.$store.state.searchSuccess);
                }else {
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//search4


        // check box click event
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex === 1) {
                //  return 'warning-row';
            } else if (rowIndex === 3) {
                //  return 'success-row';
            }
            console.log(row);
            return '';
        },

        Confirm(){
            this.dialogVisible = false
        },






        handleClick1(chk_date ){
            // this.$store.commit("setRfid_get_order_seq",auth_code );
            this.search4_1(null, null, null, chk_date);
            this.search5(null, null, null, chk_date);
        },

        handleClick2(administrative_area_level_1 ){
            // this.$store.commit("setRfid_get_order_seq",auth_code );
            this.search4_1(null, administrative_area_level_1, null, null);
            this.search5(null , administrative_area_level_1, null, null);
        },

        handleClick3(country ){
            // this.$store.commit("setRfid_get_order_seq",auth_code );
            this.search4_1(null, null, country, null);
            this.search5(null , null, country, null);
        },

        handleClick4(auth_code ){
            // this.$store.commit("setRfid_get_order_seq",auth_code );
            this.search4_2(auth_code);
            this.search5(auth_code);
        },


        geolocate: function () {
            navigator.geolocation.getCurrentPosition(position => {

                //console.log ( position.coords.latitude  );
                //console.log ( position.coords.longitude  );

                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
            });
        },

        async search5(auth_code) {
            this.loading = true;
            // default data
            let url = this.$url + '/authInfo/getLatLng';
            var reqJson = new Object();


            this.applyDateFilter(reqJson);

            reqJson.auth_code = auth_code;
            // reqJson.administrative_area_level_1 = administrative_area_level_1;
            // reqJson.country = country;
            // reqJson.chk_date = chk_date;
            // reqJson.success_fail = success_fail;


            this.locationMarkers =[];

            this.locPlaces = [];
            this.label = [];
            // this.center = [];


            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;

            this.dialogVisible = true;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO;

                // console.log(resDataJson) ;

                var tmpPosition = []
                var icon = []
                var ani = []
                for(var resData in resDataJson){
                    tmpPosition.push ({
                        lat :  Number ( resDataJson[resData]['latitude'] ) ,
                        lng :  Number ( resDataJson[resData]['longitude'] ),

                    });

                    this.center = {
                        lat:  Number ( resDataJson[resData]['latitude'] ),
                        lng: Number ( resDataJson[resData]['longitude'] ),
                    };


                    //
                    // // this.center=  ({ lat: resDataJson[resData]['latitude'], lng : resDataJson[resData]['longitude']}) ;
                    //
                    // this.center ={ lat: 37.4915792, lng: 126.8788277};


                    if (resDataJson[resData]['success_fail'] =='F') {
                        icon.push({
                            // url: 'http://maps.google.com/mapfiles/ms/icons/red.png',
                        });
                        ani.push(1)
                    }
                    else {
                        icon.push({
                            url: 'http://maps.google.com/mapfiles/ms/icons/green.png',
                            scaledSize: { width: 30, height: 30 },
                        });
                        ani.push(0)
                    }

                    this.locationMarkers.push ({
                        position : tmpPosition[resData],
                        icon: icon[resData],
                        ani:ani[resData],
                    })

                    // if (resDataJson[resData]['success_fail'] =='F') {
                    //   this.label.push({
                    //     text: resDataJson[resData]['success_fail'],
                    //     color: 'white',
                    //   });
                    // }else {
                    //   this.label.push({
                    //     text: resDataJson[resData]['success_fail'],
                    //     color: 'white',
                    //   });
                    // }
                }

                // console.log (this.label ) ;

                this.loading = false;



            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post
        },//chkQrCode



        downloadDialogExcel(){
            if (!this.tableData4_1 || this.tableData4_1.length === 0) {
                this.$message.warning("다운로드할 상세 조회 결과가 없습니다.");
                return;
            }
            const excelData = this.tableData4_1.map(item => ({
                인증코드: item.auth_code,
                회사명: item.dept_name,
                국가: item.country,
                인증날짜: item.chk_date,
                성공여부: item.success_fail,
                인증건수: item.count
            }));
            const worksheet = XLSX.utils.json_to_sheet(excelData);
            worksheet['!cols'] = [{ wch: 24 }, { wch: 35 }, { wch: 18 }, { wch: 14 }, { wch: 12 }, { wch: 12 }];
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, '상세 인증통계');
            XLSX.writeFile(workbook, `인증코드별_상세인증통계_${this.formatDate(new Date())}.xlsx`);
        },

        excelDownFuncAll(){
            if (!this.tableData4 || this.tableData4.length === 0) {
                this.$message.warning("다운로드할 조회 결과가 없습니다.");
                return;
            }
            var excepData = [];

            for (var i in this.tableData4) {
                excepData.push({
                    인증코드 : this.tableData4[i]['auth_code']
                    ,회사명 : this.tableData4[i]['dept_name']
                    ,count : this.tableData4[i]['count']
                });
            }

            this.loading = true;
            const dataWS = XLSX.utils.json_to_sheet(excepData);
            dataWS['!cols'] = [{ wch: 24 }, { wch: 40 }, { wch: 12 }];
            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '인증통계');
            const period = this.customStartDate && this.customEndDate
                ? `${this.customStartDate}_${this.customEndDate}` : '전체';
            XLSX.writeFile(wb, `인증통계_${period}.xlsx`);
            this.loading = false;
        },//excelDownFunc

    }

}
</script>
<style>
#app { font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000000;
    margin-top: 0px;
}

.grid-content-report {
    height: 380px;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}

.report-auth-code-search {
    width: 220px !important;
    margin-left: 10px;
}

.report4-search-row {
    flex-wrap: wrap;
    min-height: 44px !important;
    padding-bottom: 8px;
}

.report4-period-options {
    margin-left: 10px !important;
}

.report-date-search {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin: 6px 10px 10px;
}
.report-date-search__label { color: #303133; font-weight: 600; margin-right: 2px; }
.report-date-search .report-date-search__input.el-date-editor.el-input { width: 160px !important; }
.report-date-search__separator { color: #606266; }
.report-date-search__button { margin-left: 12px !important; }
.report-date-search__excel-button { margin-left: 4px !important; }
.report-detail-dialog .el-dialog__headerbtn {
    top: 6px !important;
    right: 6px !important;
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.report-detail-dialog .el-dialog__close { font-size: 20px; }
.dialog-excel-actions { display: flex; justify-content: flex-end; margin: 10px 0; }

.report4-auth-code-label {
    width: 70px !important;
}

</style>
